"use strict";

exports.__esModule = true;
exports.default = createConcatChildrenFunction;

var _utils = require("rsuite-utils/lib/utils");

function createConcatChildrenFunction(node, nodeValue) {
  return function (data, children) {
    if (nodeValue) {
      node = (0, _utils.findNodeOfTree)(data, function (item) {
        return nodeValue === item.value;
      });
    }

    node.children = children;
    return data.concat([]);
  };
}